// src/pages/Accounting/Receipts/components/Dashboard/FilterChips.tsx

import { useMemo } from "react";
import type { FilterKey, Receipt } from "../../types";
import { PALETTE, FILTER_LABELS } from "../../constants";

interface FilterChipsProps {
  receipts: Receipt[];
  activeFilter: FilterKey;
  onFilterChange: (filter: FilterKey) => void;
  searchQuery: string;
  onSearchChange: (q: string) => void;
}

const FILTER_ORDER: FilterKey[] = [
  "all",
  "matched",
  "needs-review",
  "unmatched",
  "processing",
];

export function FilterChips({
  receipts,
  activeFilter,
  onFilterChange,
  searchQuery,
  onSearchChange,
}: FilterChipsProps) {
  const counts = useMemo(() => {
    const base: Record<FilterKey, number> = {
      all: receipts.length,
      matched: 0,
      "needs-review": 0,
      unmatched: 0,
      processing: 0,
    };
    for (const r of receipts) base[r.matchStatus]++;
    return base;
  }, [receipts]);

  return (
    <div
      style={{
        display: "flex",
        gap: 24,
        marginBottom: 2,
        borderBottom: `1px solid ${PALETTE.line}`,
        paddingBottom: 12,
        alignItems: "center",
      }}
    >
      {FILTER_ORDER.map((key) => {
        const isActive = activeFilter === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onFilterChange(key)}
            style={{
              background: "transparent",
              border: 0,
              padding: isActive ? "4px 0 12px" : "4px 0",
              marginBottom: isActive ? -13 : 0,
              borderBottom: isActive
                ? `2px solid ${PALETTE.ink}`
                : "2px solid transparent",
              fontSize: 13,
              color: isActive ? PALETTE.ink : PALETTE.ink2,
              fontWeight: isActive ? 700 : 500,
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "baseline",
              gap: 6,
            }}
          >
            {FILTER_LABELS[key]}{" "}
            <span
              style={{
                color: isActive ? PALETTE.ink : PALETTE.ink3,
                fontWeight: 600,
                fontSize: 12,
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {counts[key]}
            </span>
          </button>
        );
      })}
      <input
        type="search"
        placeholder="Search receipts..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{
          marginLeft: "auto",
          background: "transparent",
          border: 0,
          outline: "none",
          padding: "6px 0",
          fontSize: 13,
          color: PALETTE.ink2,
          fontWeight: 500,
          width: 220,
          textAlign: "right",
        }}
      />
    </div>
  );
}